import { useEffect, useState } from "react";
import {
  findB2BMembership,
  getMemberships,
  MedicalServiceProviderType,
  Membership,
} from "@/services/core-api-adapter";

export default function useGetMemberships() {
  const [memberships, setMemberships] = useState<Membership[]>([]);
  const [firstMembership, setFirstMembership] = useState<Membership>({
    members: [],
    productDetails: {
      ...({} as any),
    },
  });
  const [b2bMembership, setB2bMembership] = useState<Membership | null>(null);
  const [membershipsFetchError, setMembershipsFetchError] = useState(false);
  const [isMembershipsLoading, setIsMembershipsLoading] = useState(true);
  const [medicalAssistanceProvider, setMedicalAssistanceProvider] = useState(
    MedicalServiceProviderType.WHATSAPP
  );

  useEffect(() => {
    const controller = new AbortController();
    setIsMembershipsLoading(true);
    getMemberships({ signal: controller.signal })
      .then((res) => {
        const memberships = "memberships" in res ? res.memberships : [];
        const b2bMembership = findB2BMembership(memberships);

        const nonUNU01Membership = memberships?.find(
          (membership) => membership.productDetails?.code !== "UNU01"
        );
        const primaryMembership = nonUNU01Membership
          ? nonUNU01Membership
          : memberships[0];

        setMemberships(memberships);
        if (primaryMembership) {
          setFirstMembership(primaryMembership);
        }
        setB2bMembership(b2bMembership);
        setMembershipsFetchError(false);
        setIsMembershipsLoading(false);

        if (nonUNU01Membership?.productDetails?.medicalServiceProvider) {
          setMedicalAssistanceProvider(
            nonUNU01Membership.productDetails.medicalServiceProvider
          );
        }
      })
      .catch(() => {
        if (controller.signal.aborted === false) {
          setMembershipsFetchError(true);
          setMemberships([]);
          setB2bMembership(null);
          setIsMembershipsLoading(false);
        }
      });
    return () => {
      controller.abort();
    };
  }, []);

  return {
    firstMembership,
    memberships,
    membershipsFetchError,
    isMembershipsLoading,
    medicalAssistanceProvider,
    b2bMembership,
  };
}
